import { render, staticRenderFns } from "./processDialog.vue?vue&type=template&id=2dcab014&scoped=true"
import script from "./processDialog.vue?vue&type=script&lang=js"
export * from "./processDialog.vue?vue&type=script&lang=js"
import style0 from "./processDialog.vue?vue&type=style&index=0&id=2dcab014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcab014",
  null
  
)

export default component.exports